import {
  USER_TOKEN_NAME,
  ADMIN_TOKEN_NAME,
  INTERNAL_TOKEN_NAME,
  USER_LOADING,
  USER_AVAILABLE,
  LOAD_USER,
  REGISTER_USER,
  LOGIN_USER,
  LOGOUT_USER,
  UPDATE_USER,
  DELETE_USER,
  AUTH_ERROR,
} from "../constants";

const initial_state = {
  loading: false,
  errors: {},
  user: {},
  approvers: [],
  isAvailable: null, // null =  no input, false = not available, true = available
  isAuthenticated: false,
  token: localStorage.getItem(USER_TOKEN_NAME),
};

export default function (state = initial_state, { type, payload }) {
  switch (type) {
    case USER_LOADING:
      return {
        ...state,
        loading: typeof payload === "boolean" ? payload : true,
      };

    case AUTH_ERROR:
      return {
        ...state,
        loading: false,
        errors: payload || { unknown: "Unknown error" },
      };

    case USER_AVAILABLE:
      return {
        ...state,
        isAvailable: payload,
        errors: {},
      };

    case LOAD_USER:
      return {
        ...state,
        ...payload,
        isAuthenticated: true,
        loading: false,
        errors: {},
      };

    case REGISTER_USER:
    case LOGIN_USER:
    case UPDATE_USER:
      localStorage.setItem(USER_TOKEN_NAME, payload.token);
      return {
        ...state,
        ...payload,
        errors: {},
      };

    case LOGOUT_USER:
    case DELETE_USER:
      localStorage.removeItem(USER_TOKEN_NAME);
      localStorage.removeItem(ADMIN_TOKEN_NAME);
      localStorage.removeItem(INTERNAL_TOKEN_NAME);

      return {
        loading: false,
        errors: {},
        user: {},
        token: null,
        isAvailable: null,
        isAuthenticated: false,
      };

    default:
      return state;
  }
}

export function verifyIsInternalUser(user) {
  if (!user) {
    return false;
  }
  if (/@messagebroadcast.com$/.test(user.email_vch)) {
    return true;
  }
  if (!user.firstname_vch) return false;

  return (
    ["read", "user", "admin", "super"].filter((item) => item === user.firstname_vch.toLowerCase())
      .length === 1
  );
}
